import React from 'react';
import { motion } from 'framer-motion';
import SecurityDashboard from '../../components/Admin/SecurityDashboard';
import AuditLog from '../../components/Admin/AuditLog';

const FraudPage = () => {
  return (
    <div className="min-h-screen py-12 px-4" data-testid="fraud-page">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-8"
        >
          <h1 className="text-4xl font-bold text-white mb-2">Sécurité & Anti-Fraude</h1>
          <p className="text-[#B8B8BA]">Détection et gestion des comptes suspects</p>
        </motion.div>

        <SecurityDashboard />
        
        {/* Journal d'Audit */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.2 }}
          className="mt-8 bg-[#1A1A1D] p-6 rounded-lg metallic-border"
        >
          <AuditLog />
        </motion.div>
      </div>
    </div>
  );
};

export default FraudPage;
